/* eslint-disable no-prototype-builtins */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import SettingsIcon from "@material-ui/icons/Settings";
import lod_ from "lodash";
import React, { Fragment, useEffect, useState, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators, compose } from "redux";
import userGroupActions from "../../redux/actions/userGroupActions.js";
import userStatusActions from "../../redux/actions/userStatusActions";
import "../../assets/css/language-selector.css";
import "../../assets/css/profil.css";
import i18n from "../../i18n";
import settings from "../../helpers/settingFunctions";
import EditProfile from "../Profile/EditProfil";
import { UserProfileComponent } from "components/UserProfileComponent";
import { AvatarProfile } from "components/UserProfileComponent";

import SnackbarStore from "pages/Cockpit/SnackbarStore.js";
import {
	FormControl,
	FormControlLabel,
	FormLabel,
	Icon,
	Radio,
	RadioGroup,
	Switch
} from "@material-ui/core";
import { useTheme } from "../../theme";
import {
	SentimentSatisfied,
	Brightness4,
	Brightness7,
	SortRounded,
	CalendarTodayRounded,
	Language,
	SignalCellularConnectedNoInternet4Bar,
	AddToQueueOutlined,
	ListAltRounded,
	AccountCircleRounded,
	GroupWork,
	PermContactCalendar,
	SupervisedUserCircleRounded,
	FilterList,
	Inbox,
	Mail
} from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
	container: {
		backgroundColor: theme.palette.background.paper,
		borderRadius: 4,
		border: `1px solid ${theme.palette.divider}`,
		boxShadow: theme.shadows[1]
	},
	sectionTitle: {
		color: theme.palette.text.primary
	},
	formLabel: {
		color: theme.palette.text.primary
	},
	colorCircle: {
		cursor: "pointer",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		position: "relative",
		transition: "transform 0.2s",
		"&:hover": {
			transform: "scale(1.1)"
		}
	},
	colorCircleSelected: {
		border: `2px solid ${theme.palette.text.primary}`
	},
	colorCircleUnselected: {
		border: `1px solid ${theme.palette.divider}`
	},
	nullColorLine: {
		position: "absolute",
		width: "70%",
		height: "2px",
		backgroundColor: theme.palette.text.secondary,
		transform: "rotate(45deg)"
	}
}));

/**
 * Team color options with i18n keys and hex values
 * Structure: { key: translation_key, value: hex_color }
 */
const TEAM_COLORS_BASE = [
	{ key: "COLORS.NONE", value: null },
	{ key: "COLORS.BLUE", value: "#0078D4" },
	{ key: "COLORS.LIGHT_BLUE", value: "#B3D6F2" },
	{ key: "COLORS.LIGHT_PURPLE", value: "#D6C7E8" },
	{ key: "COLORS.LIGHT_PINK", value: "#F2B8C6" },
	{ key: "COLORS.PEACH", value: "#F2C6B8" },
	{ key: "COLORS.PALE_YELLOW", value: "#F2E0B8" },
	{ key: "COLORS.PALE_GREEN", value: "#C6E8B8" },
	{ key: "COLORS.DARK_BLUE", value: "#2E5A87" },
	{ key: "COLORS.DARK_PURPLE", value: "#5A2E87" },
	{ key: "COLORS.BURGUNDY", value: "#872E5A" },
	{ key: "COLORS.BROWN", value: "#875A2E" },
	{ key: "COLORS.DARK_GREEN", value: "#5A872E" }
];

/**
 * Conversation filter options with i18n keys and filter codes
 * Structure: { label: translation_key, value: filter_code }
 */
const CONVERSATION_FILTER_OPTIONS = [
	{ value: "asc", label: "EDIT_FORM.filterConversationOptions.asc", icon: SortRounded },
	{ value: "date", label: "EDIT_FORM.filterConversationOptions.date", icon: CalendarTodayRounded },
	{
		value: "channel",
		label: "EDIT_FORM.filterConversationOptions.channel",
		icon: Mail
	},
	{ value: "language", label: "EDIT_FORM.filterConversationOptions.language", icon: Language },
	{
		value: "priority",
		label: "EDIT_FORM.filterConversationOptions.priority",
		icon: SignalCellularConnectedNoInternet4Bar
	},
	{
		value: "sentiment",
		label: "EDIT_FORM.filterConversationOptions.sentiment",
		icon: SentimentSatisfied
	},
	{
		value: "subState",
		label: "EDIT_FORM.filterConversationOptions.subState",
		icon: AddToQueueOutlined
	},
	{ value: "intent", label: "EDIT_FORM.filterConversationOptions.intent", icon: ListAltRounded },
	{
		value: "agent",
		label: "EDIT_FORM.filterConversationOptions.agent",
		icon: AccountCircleRounded
	},
	{ value: "skills", label: "EDIT_FORM.filterConversationOptions.skills", icon: GroupWork },
	{
		value: "contactFilter",
		label: "EDIT_FORM.filterConversationOptions.contactFilter",
		icon: PermContactCalendar
	},
	{
		value: "convShowFilter",
		label: "EDIT_FORM.filterConversationOptions.convShowFilter",
		icon: SupervisedUserCircleRounded
	},
	{
		value: "actionFilter",
		label: "EDIT_FORM.filterConversationOptions.actionFilter",
		icon: FilterList
	},
	{ value: "direction", label: "EDIT_FORM.filterConversationOptions.direction", icon: Inbox }
];

function Profile(props) {
	const selectedAssistantID = useSelector(state => state.selectedAssistantID);
	const classes = useStyles();

	const { isDarkMode, toggleTheme } = useTheme();
	const [selectedUser, setSelectedUser] = useState({});
	const [editProfile, setEditProfile] = useState({ open: false });
	const [showAlert, setShowAlert] = useState({ open: false, success: true });
	const [languages, setLanguages] = useState(["FR", "EN"]);
	const [signatures, setSignatures] = useState([]);
	const [mySign, setMysign] = useState("");
	const [isAssistantSwitched, setIsAssistantSwitched] = useState(false);

	useEffect(() => {
		if (props.userStatus.auth && props.userStatus.auth.user) {
			setSelectedUser(props.userStatus.auth.user);
		}
	}, [props.userStatus.auth]);

	useEffect(() => {
		setIsAssistantSwitched(true);
	}, [selectedAssistantID]);

	/**
	 * Get signatures depends current assistant id
	 */

	useEffect(() => {
		if (
			props.userStatus.auth &&
			props.userStatus.auth.user &&
			props.userStatus.auth.user.signatures
		) {
			let signatures = props.userStatus.auth.user.signatures;

			let mySignature =
				signatures &&
				signatures.length > 0 &&
				signatures !== undefined &&
				signatures.filter(s => s.assistantID === selectedAssistantID).map(s => s);
			setSignatures(signatures);
			setMysign(mySignature[0]);
		} else {
			setSignatures("");
			setMysign("");
		}
	}, [props.userStatus.auth, selectedAssistantID, mySign]);

	/**
	 * Set user options values when user cockpit settings are updated
	 */
	useEffect(() => {
		setValueMessage(
			props?.userStatus?.auth?.user?.cockpitSettings?.cockpitTextVersion || "default"
		);
		setValueDisplay(props?.userStatus?.auth?.user?.cockpitSettings?.displayEditor || false);
		setValueOrder(
			props?.userStatus?.auth?.user?.cockpitSettings?.forceMessageSortNewerToOlder || false
		);
		setValueShowSignatureAndForward(
			props?.userStatus?.auth?.user?.cockpitSettings?.showSignatureAndForward || false
		);

		setValueShowConversationAfterResponse(
			props?.userStatus?.auth?.user?.cockpitSettings?.showConversationAfterResponse || false
		);

		setValueSubject(
			props?.userStatus?.auth?.user?.cockpitSettings?.defaultTopicOrSubject || "default"
		);
		setValueTabInfo(props?.userStatus?.auth?.user?.cockpitSettings?.openDefaultTabInfo || "close");

		setValueColor(props?.userStatus?.auth?.user?.cockpitSettings?.color || null);
		setValueDarkMode(props?.userStatus?.auth?.user?.cockpitSettings?.darkMode || false);
		setValueConversationFilters(
			props?.userStatus?.auth?.user?.cockpitSettings?.visibleConversationFilters ??
				CONVERSATION_FILTER_OPTIONS.map(f => f.value)
		);
	}, [props?.userStatus?.auth?.user?.cockpitSettings]);

	const handleCloseUserEditor = () => {
		setEditProfile({ open: false });
	};

	const hideAlert = () => {
		setShowAlert({ open: false, success: true });
	};

	const handleSaveProfile = userToUpdate => {
		setSelectedUser({ ...selectedUser, picture: "" });
		if (userToUpdate !== selectedUser.language) {
			const newLanguage = userToUpdate.language.toLowerCase();
			i18n.changeLanguage(newLanguage);
			localStorage.setItem("lang", newLanguage);
		}
		props.userStatusActions.saveUserdata(
			userToUpdate,
			() => {
				setShowAlert({ open: true, success: true });
			},
			() => {
				setShowAlert({ open: true, success: false });
			}
		);
		setEditProfile({ open: false });
	};

	const getRole = searchedRole => {
		const role = settings.getRoles().find(role => role.value === searchedRole);
		if (role) {
			return i18n.t(`EDIT_FORM.roles.${role.code}`);
		} else {
			return searchedRole;
		}
	};

	const [valueMessage, setValueMessage] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.cockpitTextVersion || "default"
	);

	const [valueDisplay, setValueDisplay] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.displayEditor || true
	);

	const [valueOrder, setValueOrder] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.forceMessageSortNewerToOlder || false
	);

	// Show Signature And Forward
	const [valueShowSignatureAndForward, setValueShowSignatureAndForward] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.showSignatureAndForward || false
	);

	// Show conversation after response
	const [valueShowConversationAfterResponse, setValueShowConversationAfterResponse] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.showConversationAfterResponse || false
	);

	// Color Profile Option state
	const [valueColor, setValueColor] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.color || null
	);

	// Dark Mode preference state
	const [valueDarkMode, setValueDarkMode] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.darkMode || false
	);

	// Conversation filters to show in cockpit state
	const [valueConversationFilters, setValueConversationFilters] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.visibleConversationFilters ??
			CONVERSATION_FILTER_OPTIONS.map(f => f.value)
	);

	/**
	 * Memoized team colors with translations
	 * Recreates only when i18n language changes
	 */
	const TEAM_COLORS = useMemo(() => {
		return TEAM_COLORS_BASE.map(color => ({
			name: i18n.t(color.key),
			value: color.value
		}));
	}, [i18n.language]);

	/**
	 * Memoized filter list to show with translations
	 * Recreates only when i18n language changes
	 */
	const FILTER_SHOW = useMemo(() => {
		return CONVERSATION_FILTER_OPTIONS.map(filter => ({
			name: i18n.t(filter.label),
			value: filter.value,
			icon: filter.icon
		}));
	}, [i18n.language]);

	const [valueSubject, setValueSubject] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.defaultTopicOrSubject || "default"
	);

	const [valueTabInfo, setValueTabInfo] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.openDefaultTabInfo || "close"
	);

	const dispatch = useDispatch();

	const handleChangeMessage = e => {
		changeOption("formatMessage", e.target.value);

		//dispatch(cockpitActions.changeFormatMessage(channelCode, initialDraft));
		setValueMessage(e.target.value);
	};

	const handleChangeDisplay = e => {
		changeOption("displayMessage", e.target.value);

		setValueDisplay(e.target.value);
	};

	const handleChangeOrder = e => {
		changeOption("orderMessage", e.target.value);
		setValueOrder(e.target.value);
	};

	// Handle Show Signature And Forward Change
	const handleChangeShowSignatureAndForward = e => {
		changeOption("showSignatureAndForward", e.target.value);
		setValueShowSignatureAndForward(e.target.value);
	};

	// Handle Show Conversation after response
	const handleChangeShowConversationAfterResponse = e => {
		changeOption("showConversationAfterResponse", e.target.value);
		setValueShowConversationAfterResponse(e.target.value);
	};

	// Handle Dark Mode Change
	const handleChangeDarkMode = e => {
		toggleTheme();
		changeOption("darkMode", e.target.checked);
		setValueDarkMode(e.target.checked);
	};

	// Handle Color Change
	const handleChangeColor = color => {
		changeOption("colorProfile", color);
		setValueColor(color);
	};

	const handleChangeSubject = e => {
		changeOption("subjectMessage", e.target.value);
		setValueSubject(e.target.value);
	};

	const handleChangeTabInfo = e => {
		changeOption("showTabInfo", e.target.value);
		setValueTabInfo(e.target.value);
	};

	// Toggle conversation filter in the list of conversation filters to show in cockpit
	const handleToggleConversationFilter = filterCode => {
		const nextValue = valueConversationFilters.includes(filterCode)
			? valueConversationFilters.filter(filter => filter !== filterCode)
			: [...valueConversationFilters, filterCode];

		changeOption("visibleConversationFilters", nextValue);
		setValueConversationFilters(nextValue);
	};

	const changeOption = (code, value) => {
		dispatch(userStatusActions.saveOptionUser({ code, action: code, value }));
	};

	return (
		<Fragment>
			<Box className={`customScrollBar ${classes.container}`} overflow="auto">
				<Grid item xs={12}>
					<Box component="div" width="100%" height="97vh" display="flex" flexDirection="column">
						{selectedUser && (
							<Box height="100%" p={2} m={1}>
								<Box
									component="div"
									width="90%"
									height="71vh"
									display="flex"
									flexDirection="column"
								>
									<Box display="flex" flexWrap="wrap" alignItems="center" mb={1} ml={10}>
										<AvatarProfile
											user={selectedUser}
											role={getRole(selectedUser.role)}
											classes={classes}
										/>
									</Box>
									<Grid container>
										{/* <Grid item xs={4}>
											<Box overflow="auto" className="customScrollBar" ml={10}>
												<UserProfileComponent
													settings={settings}
													user={selectedUser}
													displayPhone={true}
													classes={classes}
													signature={mySign?.signature}
												/>
											</Box>
										</Grid> */}
										<Grid item xs={8}>
											<Box overflow="auto" className="customScrollBar" ml={10}>
												<Box display="flex" alignItems="center" my={2} mt={3}>
													<SettingsIcon color={isDarkMode ? "inherit" : "action"} />
													<Box ml={1} fontWeight="fontWeightBold" className={classes.sectionTitle}>
														{`${i18n.t("EDIT_FORM.profilOption")} : `}
													</Box>
												</Box>

												<Box fontSize="h5.fontSize" fontWeight="fontWeightBold" m={1}>
													<Box style={{ alignSelf: "center" }} className={classes.imgSign}>
														<FormControl>
															<FormLabel id="demo-row-radio-buttons-group-label">
																{i18n.t("EDIT_FORM.titleOptionMessage")}
															</FormLabel>
															<RadioGroup
																row
																onChange={e => handleChangeMessage(e)}
																aria-labelledby="demo-row-radio-buttons-group-label"
																name="row-radio-buttons-group"
																value={valueMessage}
															>
																<FormControlLabel
																	value="default"
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.defaultOption")}
																/>
																<FormControlLabel
																	value="clean"
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.optionTextClean")}
																/>
																<FormControlLabel
																	value="html"
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.optionTextHtml")}
																/>
															</RadioGroup>
														</FormControl>
													</Box>

													<Box style={{ alignSelf: "center" }} className={classes.imgSign}>
														<FormControl>
															<FormLabel id="demo-row-radio-buttons-group-label">
																{i18n.t("EDIT_FORM.titleOptionDisplay")}
															</FormLabel>
															<RadioGroup
																onChange={e => handleChangeDisplay(e)}
																row
																aria-labelledby="demo-row-radio-buttons-group-label"
																name="row-radio-buttons-group"
																value={valueDisplay}
															>
																<FormControlLabel
																	value={true}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.oppenDisplay")}
																/>
																<FormControlLabel
																	value={false}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.hiddenDisplay")}
																/>
															</RadioGroup>
														</FormControl>
													</Box>
													<Box style={{ alignSelf: "center" }} className={classes.imgSign}>
														<FormControl>
															<FormLabel id="demo-row-radio-buttons-group-label">
																{i18n.t("EDIT_FORM.titleOptionOrder")}
															</FormLabel>
															<RadioGroup
																onChange={e => handleChangeOrder(e)}
																row
																aria-labelledby="demo-row-radio-buttons-group-label"
																name="row-radio-buttons-group"
																value={valueOrder}
															>
																<FormControlLabel
																	value={false}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.orderOptionDefault")}
																/>
																<FormControlLabel
																	value={true}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.orderOption")}
																/>
															</RadioGroup>
														</FormControl>
													</Box>
													<Box style={{ alignSelf: "center" }} className={classes.imgSign}>
														<FormControl>
															<FormLabel id="demo-row-radio-buttons-group-label">
																{i18n.t("EDIT_FORM.titleOptionSubject")}
															</FormLabel>
															<RadioGroup
																onChange={e => handleChangeSubject(e)}
																row
																aria-labelledby="demo-row-radio-buttons-group-label"
																name="row-radio-buttons-group"
																value={valueSubject}
															>
																<FormControlLabel
																	value={"default"}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.defaultOption")}
																/>
																<FormControlLabel
																	value={"subject"}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.subjectOption")}
																/>
																<FormControlLabel
																	value={"topic"}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.topicOption")}
																/>
															</RadioGroup>
														</FormControl>
													</Box>

													<Box style={{ alignSelf: "center" }} className={classes.imgSign}>
														<FormControl>
															<FormLabel id="demo-row-radio-buttons-group-label">
																{i18n.t("EDIT_FORM.titleOptionTabInfo")}
															</FormLabel>
															<RadioGroup
																onChange={e => handleChangeTabInfo(e)}
																row
																aria-labelledby="demo-row-radio-buttons-group-label"
																name="row-radio-buttons-group"
																value={valueTabInfo}
															>
																<FormControlLabel
																	value={"close"}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.tabCloseOption")}
																/>
																<FormControlLabel
																	value={"open"}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.tabOpenOption")}
																/>

																<FormControlLabel
																	value={"openAll"}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.tabOpenAllOption")}
																/>
															</RadioGroup>
														</FormControl>
													</Box>

													{/* Toggle for Show Signature And Forward option */}
													<Box style={{ alignSelf: "center" }} className={classes.imgSign}>
														<FormControl>
															<FormLabel id="demo-row-radio-buttons-group-label-signature">
																{i18n.t("EDIT_FORM.titleOptionShowSignatureAndForward")}
															</FormLabel>
															<RadioGroup
																onChange={e => handleChangeShowSignatureAndForward(e)}
																row
																aria-labelledby="demo-row-radio-buttons-group-label-signature"
																name="row-radio-buttons-group-signature"
																value={valueShowSignatureAndForward}
															>
																<FormControlLabel
																	value={true}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.showDisplay")}
																/>
																<FormControlLabel
																	value={false}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.notShowDisplay")}
																/>
															</RadioGroup>
														</FormControl>
													</Box>

													{/* Toggle for do not close conversation after send */}
													<Box style={{ alignSelf: "center" }} className={classes.imgSign}>
														<FormControl>
															<FormLabel id="demo-row-radio-buttons-group-label-reponse">
																{i18n.t("EDIT_FORM.titleOptionCloseConversationAfterResponse")}
															</FormLabel>
															<RadioGroup
																onChange={e => handleChangeShowConversationAfterResponse(e)}
																row
																aria-labelledby="demo-row-radio-buttons-group-label-reponse"
																name="row-radio-buttons-group-reponse"
																value={valueShowConversationAfterResponse}
															>
																<FormControlLabel
																	value={true}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.showDisplay")}
																/>
																<FormControlLabel
																	value={false}
																	control={<Radio />}
																	label={i18n.t("EDIT_FORM.notShowDisplay")}
																/>
															</RadioGroup>
														</FormControl>
													</Box>

													{/* Toggle for list of preference filter conversation want to show */}
													<Box style={{ alignSelf: "center" }} className={classes.imgSign}>
														<FormLabel id="conversation-filters-visibility-label">
															{i18n.t("EDIT_FORM.titleOptionFiltreConversation")}
														</FormLabel>
														<Box display="flex" flexWrap="wrap" mt={1} mb={2} style={{ gap: 12 }}>
															{FILTER_SHOW.map(option => {
																// Check if the filter is active (in the list of filters to show in cockpit)
																const active = valueConversationFilters.includes(option.value);
																const IconComp = option.icon;
																return (
																	<Box
																		key={option.value}
																		onClick={() => handleToggleConversationFilter(option.value)}
																		display="flex"
																		alignItems="center"
																		style={{
																			gap: 6,
																			padding: "5px 12px",
																			borderRadius: 20,
																			cursor: "pointer",
																			fontSize: 13,
																			fontWeight: active ? 600 : 400,
																			border: active
																				? "2px solid #1976d2"
																				: `1px solid ${isDarkMode ? "var(--dark-border-color)" : "#DBDBDB"}`,
																			backgroundColor: active
																				? isDarkMode
																					? "rgba(25,118,210,0.2)"
																					: "rgba(25,118,210,0.08)"
																				: isDarkMode
																					? "var(--dark-bg-elevated)"
																					: "#FAFAFA",
																			color: active
																				? "#1976d2"
																				: isDarkMode
																					? "var(--dark-text-secondary)"
																					: "#555",
																			transition: "all 0.15s ease",
																			userSelect: "none"
																		}}
																	>
																		{IconComp && (
																			<IconComp
																				style={{
																					fontSize: 15,
																					opacity: active ? 1 : 0.55
																				}}
																			/>
																		)}
																		{option.name}
																	</Box>
																);
															})}
														</Box>
													</Box>

													{/* Toggle for Change color profile option */}
													<Box style={{ alignSelf: "center" }} className={classes.imgSign}>
														<FormControl>
															<FormLabel id="demo-row-radio-buttons-group-label-color">
																{i18n.t("EDIT_FORM.titleOptionColor")}
															</FormLabel>

															<Box display="flex" flexWrap="wrap" mt={1}>
																{TEAM_COLORS.map(color => (
																	<Box
																		mr={1}
																		key={color.value}
																		onClick={() => handleChangeColor(color.value)}
																		sx={{
																			width: 36,
																			height: 36,
																			borderRadius: "50%",
																			backgroundColor:
																				color.value ||
																				(isDarkMode ? "var(--dark-bg-elevated)" : "#F5F5F5"),
																			cursor: "pointer",
																			border:
																				valueColor === color.value
																					? `4px solid ${isDarkMode ? "var(--dark-text-primary)" : "#000"}`
																					: `1px solid ${isDarkMode ? "var(--dark-border-color)" : "#DBDBDB"}`,
																			display: "flex",
																			alignItems: "center",
																			justifyContent: "center",
																			position: "relative"
																		}}
																		title={color.name}
																	>
																		{color.value === null && (
																			<Box
																				sx={{
																					position: "absolute",
																					width: "70%",
																					height: "2px",
																					backgroundColor: isDarkMode
																						? "var(--dark-text-secondary)"
																						: "#999",
																					transform: "rotate(45deg)"
																				}}
																			/>
																		)}
																	</Box>
																))}
															</Box>
														</FormControl>
													</Box>

													{/* Toggle for active dark mode or light mode */}
													<Box
														style={{ alignSelf: "center", marginTop: 10 }}
														className={classes.imgSign}
													>
														<FormControl>
															<FormLabel
																id="demo-row-radio-buttons-group-dark-mode"
																style={{ marginBottom: 5 }}
															>
																{i18n.t("EDIT_FORM.titleOptionDarkMode")}
															</FormLabel>

															<Box
																style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
															>
																<Icon style={{ color: isDarkMode ? "white" : "gray" }}>
																	{isDarkMode ? <Brightness4 /> : <Brightness7 />}
																</Icon>
																<Box
																	disableTypography={true}
																	primary={
																		isDarkMode
																			? props.t("THEME.lightMode")
																			: props.t("THEME.darkMode")
																	}
																	style={{ color: isDarkMode ? "white" : "" }}
																/>
																<Switch
																	color="primary"
																	checked={valueDarkMode}
																	onChange={e => handleChangeDarkMode(e)}
																	size="small"
																	style={{ marginLeft: "auto" }}
																/>
															</Box>
														</FormControl>
													</Box>
												</Box>
											</Box>
										</Grid>
									</Grid>
								</Box>
							</Box>
						)}
					</Box>
				</Grid>
			</Box>
			{editProfile.open && (
				<EditProfile
					open={editProfile.open}
					mode={editProfile.mode}
					handleCloseUserEditor={handleCloseUserEditor}
					handleSaveProfile={handleSaveProfile}
					langues={languages}
					userLanguage={selectedUser.language}
					userMobilePhone={selectedUser.mobilePhone}
					userDirectPhone={selectedUser.directPhone}
					user={selectedUser}
					signatures={signatures}
					mySign={mySign}
				/>
			)}
			<SweetAlert
				success={showAlert.success}
				error={!showAlert.success}
				title={showAlert.success ? i18n.t("alert.save") : i18n.t("alert.cannot")}
				timeout={2000}
				show={showAlert.open}
				onConfirm={hideAlert}
				onCancel={hideAlert}
				allowEscape={true}
				customButtons={
					<Button className="success" onClick={hideAlert}>
						{i18n.t("alert.confirm")}
					</Button>
				}
			/>
			<SnackbarStore />
		</Fragment>
	);
}

function mapStateToProps(state) {
	return state;
}
function mapDispatchToProps(dispatch) {
	return {
		userStatusActions: bindActionCreators(userStatusActions, dispatch),
		userGroupActions: bindActionCreators(userGroupActions, dispatch)
	};
}

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(Profile);
